import { useTranslation } from 'react-i18next';
import { Title } from 'src/components';
import styles from "./styles.module.css";
import { useCallback, useState } from 'react';
import { Element, scroller } from 'react-scroll';
import { Link } from 'react-router-dom';
import { servicesData } from './data';


const Services = () => {
    const { t, i18n } = useTranslation(["home"]);
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    const toggleSlide = useCallback(() => {
        setIsExpanded((oldExpand) => {
            if (oldExpand) {
                // Scroll to the top of the element when collapsing
                scroller.scrollTo("homeServices", {
                    duration: 600,
                    delay: 0,
                    smooth: "easeInOutQuart",
                    offset: -50, // Adjust offset if you have a fixed header
                });
            }
            return !oldExpand
        });
    }, []);



    return (
        <Element data-aos="fade-up" name="services" className={styles.services}>
            <div className={`container ${styles.sectionCon}`}>
                <Title lgTitle={t("services.title")} smTitle={t("services.subTitle")} />
                <div className={styles.contentCon}>
                    <div className='row'>
                        {servicesData.map((service, index) => (
                            <div key={`${service.title.en}-service`} className='col-11 col-md-6 col-lg-4 px-2 mx-auto'>
                                <div className={styles.item}>
                                    <div className={styles.imgCon}>
                                        <img src={service.img || "https://i.pinimg.com/474x/41/de/f0/41def0c245c762643cf513fa7efe81b3.jpg"} alt="Text" />
                                    </div>
                                    <div className={styles.overlay}>
                                        <h4 className={styles.title}>
                                            {service.title[i18n.language]}
                                        </h4>
                                        <div className={styles.content}>
                                            <p>
                                                {service.text[i18n.language]}
                                            </p>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Element>
    )
}

export default Services;